import * as tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';

function buildItemTrackingObject({ index, item }) {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    return {
        id: `promo-banner-${position}`,
        name: `Promo Banner #${position}`,
        creative: getPromoCreative(url),
        position: position,
    };
}

function trackPromoImpressions({ items, startingIndex }) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) =>
            buildItemTrackingObject({ index: index + startingIndex, item })
        ),
    });
}

function trackPromoClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [buildItemTrackingObject({ index, item })],
    });
}

export { trackPromoImpressions, trackPromoClick };
